import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

const variants: Record<string, { classes: string; glow: boolean }> = {
  ACTIVE: { classes: "bg-emerald-500/15 text-emerald-400 dark:text-emerald-400 border-emerald-500/25", glow: true },
  INACTIVE: { classes: "bg-zinc-500/15 text-zinc-500 dark:text-zinc-400 border-zinc-500/25", glow: false },
  PENDING: { classes: "bg-amber-500/15 text-amber-600 dark:text-amber-400 border-amber-500/25", glow: true },
  DELIVERED: { classes: "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400 border-emerald-500/25", glow: false },
  FAILED: { classes: "bg-rose-500/15 text-rose-600 dark:text-rose-400 border-rose-500/25", glow: false },
  SUPERSEDED: { classes: "bg-blue-500/15 text-blue-600 dark:text-blue-400 border-blue-500/25", glow: false },
  SKIPPED: { classes: "bg-orange-500/15 text-orange-600 dark:text-orange-400 border-orange-500/25", glow: false },
}

const fallback = { classes: "bg-zinc-500/15 text-zinc-500 border-zinc-500/25", glow: false }

export function StatusBadge({ status }: { status: string }) {
  const variant = variants[status] ?? fallback

  return (
    <Badge
      variant="outline"
      className={cn(
        "font-mono text-[0.6875rem] font-medium tracking-wide px-1.5 py-0 gap-1.5",
        variant.classes,
      )}
    >
      {variant.glow && (
        <span
          className={cn(
            "inline-block h-1.5 w-1.5 rounded-full shrink-0",
            status === "ACTIVE" && "bg-emerald-500 animate-glow text-emerald-500",
            status === "PENDING" && "bg-amber-500 animate-glow text-amber-500",
          )}
        />
      )}
      {status}
    </Badge>
  )
}
